export const LoginRoutesConst = {
  Dashboard: "Dashboard",
  Patient: "Patient",
  UserProfile: "UserProfile",
  UserList: "UserList",
  UserAdd: "UserAdd",
  UserLogout: "UserLogout",
  Retention: "Retention",
} as const;
